import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "m5.5 0.75 10.72 10.72a0.749 0.749 0 0 1 0 1.06L5.5 23.25",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}));
});
export default SvgArrowRight;
